<template>
  <div>
    <div 
      class="hover:ts-shadow-md ts-border ts-cursor-pointer ts-border-gray-300 ts-mb-4 ts-rounded-md ts-overflow-hidden ts-mx-auto ts-px-3 ts-py-2 ts-w-1/2"
    >
      <div class="ts-pt-1/2 ts-relative">
        <label for="logo-image" class="ts-w-full ts-h-full ts-cursor-pointer ts-absolute ts-top-0">
          <img id="logo" class="ts-w-full ts-h-full ts-object-contain" :src="logo_file_src" alt />
        </label>
      </div>
      <input
        type="file"
        id="logo-image"
        ref="logoimage"
        style="display:none"
        @change="onFileChange"
      />
      <!-- <div class="col-md-12 text-center">
        <label for="logo-image">
          <img id="logo" class="ts-w-20" :src="logo_file_src" alt />
        </label>
        <div class="validate ts-text-xs" v-if="errors.has('logo_file')">
          {{ errors.first('logo_file') }}
        </div>
        <input
          type="file"
          id="logo-image"
          ref="logoimage"
          style="display:none"
          @change="onFileChange"
        />
      </div> -->
    </div>
    <div class="ts-space-y-2">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{ $t('company.prefixCode') }}</label>
          <input
            :readonly="model.company_id"
            type="text" class="form-control" v-model.trim="model.prefix_code" />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('prefix_code')"
          >{{ errors.first('prefix_code') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs">{{ $t('company.companyNameKH') }}</label>
          <input type="text" class="form-control" v-model.trim="model.company_name_kh" />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('company_name_kh')"
          >{{ errors.first('company_name_kh') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">
            {{
            $t('company.companyNameEN')
            }}
          </label>
          <input type="text" class="form-control" v-model.trim="model.company_name_en" />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('company_name_en')"
          >{{ errors.first('company_name_en') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{ $t('company.phone') }}</label>
          <input type="text" class="form-control" v-model.trim="model.company_phone" />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('company_phone')"
          >{{ errors.first('company_phone') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs">{{ $t('company.email') }}</label>
          <input type="email" class="form-control" v-model.trim="model.company_email" />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('company_email')"
          >{{ errors.first('company_email') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs">{{ $t('company.website') }}</label>
          <input type="text" class="form-control" v-model="model.company_website" />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('company_website')"
          >{{ errors.first('company_website') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs">{{ $t('company.openingHours') }}</label>
          <input type="text" class="form-control" v-model="model.opening_hours" />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('opening_hours')"
          >{{ errors.first('opening_hours') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs">{{ $t('company.address') }}</label>
          <textarea rows="3" class="form-control" v-model.trim="model.company_address"></textarea>
          <div
            class="validate ts-text-xs"
            v-if="errors.has('company_address')"
          >{{ errors.first('company_address') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-mt-3 text-right">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{
            $t('cancel')
            }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            @click.prevent="onSave"
            :waiting="waiting"
          >{{ $t('save') }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            :waiting="waiting"
          >{{ $t('update') }}</ts-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'companyForm',
  data() {
    return {
      errors: new Errors(),
      logo_file: null,
      logo_file_src: require('../../../assets/upload.png'),
      waiting: false,
      model: {
        company_id: null,
        prefix_code: null,
        company_name_kh: null,
        company_name_en: null,
        company_address: null,
        company_phone: null,
        company_email: null,
        company_website: null,
        opening_hours: null,
        company_logo: null
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('corporate/company', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onFileChange() {
      const file = this.$refs.logoimage.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          reader.readAsDataURL(file)
          this.logo_file = file
        } else {
          this.logo_file_src = require('../../../assets/upload.png')
          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },
    async uploadLogo() {
      if ((this.logo_file instanceof File) | Blob) {
        let formData = new FormData()
        formData.append('file', this.logo_file)
        let response = await this.$store.dispatch(
          'corporate/company/upload',
          formData
        )
        this.model.company_logo = response
      }
      return ''
    },
    async onSave() {
      this.waiting = true
      await this.uploadLogo()
      this.$store
        .dispatch('corporate/company/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async onUpdate() {
      this.waiting = true
      await this.uploadLogo()
      this.$store
        .dispatch('corporate/company/update', {
          id: this.model.company_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.company_id = this.edit_data.company_id
        this.model.prefix_code = this.edit_data.prefix_code
        this.model.company_name_kh = this.edit_data.company_name_kh
        this.model.company_name_en = this.edit_data.company_name_en
        this.model.company_address = this.edit_data.company_address
        this.model.company_phone = this.edit_data.company_phone
        this.model.company_email = this.edit_data.company_email
        this.model.company_website = this.edit_data.company_website
        this.model.opening_hours = this.edit_data.opening_hours
        this.model.company_logo = this.edit_data.company_logo
        if (this.edit_data.company_logo) {
          this.logo_file_src = this.edit_data.company_logo
        }
      }
    }
  }
}
</script>
